import { render, staticRenderFns } from "./Terms-Conditions.vue?vue&type=template&id=40478a9a"
import script from "./Terms-Conditions.vue?vue&type=script&lang=js"
export * from "./Terms-Conditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports